import { Toast,NavBar, Icon, List, ImagePicker } from "antd-mobile";
import React from "react";
import { connect } from "react-redux";
import { applyListInfoAction } from "../../action/apply/applyListInfo";
import axios from "axios";
import "./style/paymentSuccessful.css";
class PaymentSuccessful extends React.Component {
  goBack = () => {

    this.props.history.goBack();
    // alert("提示", "确定要取消支付吗？", [
    //   { text: "否" },
    //   {
    //     text: "是",
    //     onPress: () => {
    //       this.props.history.goBack();
    //     },
    //   },
    // ]);
  };

  constructor(props) {
    super(props);
    this.state = {
    };
    this.payParam = (this.props.location && this.props.location.payParam) || props || {};
  }

  clearRedux = () => {
    const reduxData = [
      "applyListInfo",
      "czjeSelect",
      "paymentType",
      "invoiceType",
      "patientName",
      "invoiceTitle",
      "salesBarCode",
      "czfs",
      "salesRepresentative",
      "money",
      "v",
      "status",
      "paidRemark",
      "isMonthlyStatement",
      "needAdd",
    ];
    for (let pop in reduxData) {
      this.props.applyListInfoAction({
        type: reduxData[pop],
        data: null,
      });
    }
  };

  componentWillUnmount() {
    Toast.hide();
   // this.clearRedux();
  }

  render() {
    return (
      <div className="paymentSuccessful">

        <img
          style={{ width: "1rem", marginTop: "0.5rem" }}
          alt=""
          src={require("../img/zfcg.svg")}
        ></img>
        <span style={{ marginTop: "0.2rem" }}>下单成功</span>
        <div className="content">
          <div className="item">
            <span style={{ color: "#999999" }}>支付金额 </span>
            <span>
              {this.props.location.query && this.props.location.query.money}元
            </span>
          </div>
          <div className="item">
            <span style={{ color: "#999999" }}>申请单条码</span>
            <span>
              {this.props.location.query &&
                this.props.location.query.salesBarCode}
            </span>
          </div>
        </div>
        <div className="foot">
          <span
            className="submit"
            onClick={() => {
                this.goBack();
            }}
          >
            返回
          </span>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.applyListInfoReducer,
    ...state.paymentReducer,
  };
}

export default connect(mapStateToProps, { applyListInfoAction })(
  PaymentSuccessful
);
